import { CountryIso3166 } from "@tfg/types/constants/country.constants"

type Address = {
  street: string | null
  city: string | null
  postalCode: string | null
  country: CountryIso3166
  rawAddress?: string | null
}

const trimmedNonEmptyParts = (
  parts: readonly (string | null | undefined)[]
): string[] =>
  parts.map((part) => part?.trim() ?? "").filter((part) => part.length > 0)

export function formatAddress(site: Address): string {
  const hasStreet =
    site.street !== null &&
    site.street !== undefined &&
    site.street.trim().length > 0

  if (hasStreet) {
    const parts = trimmedNonEmptyParts([
      site.street,
      site.postalCode,
      site.city,
    ])
    return parts.join(", ")
  }

  const raw = site.rawAddress?.trim()
  if (raw !== undefined && raw.length > 0) {
    return raw
  }

  return site.country
}
